import { AssetNames } from "@utils/types";
import { BaseCharacterGender, HelmetTexture, HelmetType } from "mmo-common";
import { Vector3 } from "realms-engine";

export interface HelmetTextureAssetConfig {
  asset: AssetNames;
  transparent?: boolean;
}

export const HELMET_TEXTURE_ASSET_MAPPING: {
  [helmetType in HelmetType]: {
    [texture in HelmetTexture<helmetType>]: HelmetTextureAssetConfig;
  };
} = {
  [HelmetType.Spartan]: {
    metalKnight: {
      asset: "helmetSpartanMetalKnightTexture",
      transparent: true,
    },
    shogun: { asset: "helmetSpartanShogunTexture" },
  },
  [HelmetType.Hood]: {
    assassin: {
      asset: "helmetHoodAssassinTexture",
    },
  },
};

export const HELMET_TYPE_MAPPING: {
  [helmetType in HelmetType]: {
    asset: AssetNames;
    transformation: {
      [g in BaseCharacterGender]: {
        position: Vector3;
        rotation: Vector3;
      };
    };
    hide: {
      hairBase?: boolean;
      hairBack?: boolean;
      hairFringe?: boolean;
      hairSide?: boolean;
      hairTail?: boolean;
      moustache?: boolean;
      beard?: boolean;
      ears?: boolean;
    };
  };
} = {
  [HelmetType.Spartan]: {
    asset: "helmetSpartan",
    transformation: {
      [BaseCharacterGender.Male]: {
        position: {
          x: 160,
          y: 140,
          z: 0,
        },
        rotation: {
          x: (-1 * Math.PI) / 2,
          y: 0,
          z: 0,
        },
      },
      [BaseCharacterGender.Female]: {
        position: {
          x: 160,
          y: 180,
          z: 0,
        },
        rotation: {
          x: (-1 * Math.PI) / 2,
          y: 0,
          z: 0,
        },
      },
    },
    hide: {
      hairBase: true,
      hairBack: true,
      hairFringe: true,
      hairSide: true,
      hairTail: true,
      ears: true,
    },
  },
  [HelmetType.Hood]: {
    asset: "helmetHood",
    transformation: {
      [BaseCharacterGender.Male]: {
        position: {
          x: 190,
          y: 40,
          z: 0,
        },
        rotation: {
          x: (-1 * Math.PI) / 2,
          y: 0,
          z: 0,
        },
      },
      [BaseCharacterGender.Female]: {
        position: {
          x: 190,
          y: 40,
          z: 0,
        },
        rotation: {
          x: (-1 * Math.PI) / 2,
          y: 0,
          z: 0,
        },
      },
    },
    hide: {
      hairBase: true,
      hairBack: true,
      hairTail: true,
      ears: true,
    },
  },
};
